import React, { useState } from 'react';
import { Icons, ImpContainer, ImpFlex, ImpFlexItem, ImpProgressBarItem, } from '../..';
import { TRANSITION_DURATION, TRANSITION_DURATION_MS, } from '../../Molecules/ImpProgressBarItem/ImpProgressBarItem';
const FLEX_ITEM_TRANSITION_DURATION = 'flex-grow 0.18s ease-in-out';
const delayChange = (setup, follow) => {
    setup();
    setTimeout(() => {
        follow();
    }, TRANSITION_DURATION_MS);
};
export const useProgressBar = (config, initialMainStep = 0) => {
    const [currentMainStep, setCurrentMainStep] = useState(initialMainStep);
    const [currentSubstep, setCurrentSubStep] = useState(0);
    const moveForward = () => {
        var _a, _b;
        const maxMainSteps = config.length;
        if (currentMainStep <= maxMainSteps - 1) {
            const maxSubsteps = ((_b = (_a = config[currentMainStep]) === null || _a === void 0 ? void 0 : _a.substeps) === null || _b === void 0 ? void 0 : _b.length) || 0;
            if (maxSubsteps !== 0 && currentSubstep < maxSubsteps - 1) {
                setCurrentSubStep((prev) => prev + 1);
            }
            else {
                setCurrentMainStep((prev) => prev + 1);
                delayChange(() => setCurrentSubStep(-1), () => setCurrentSubStep(0));
            }
        }
        else {
            setCurrentMainStep(maxMainSteps);
        }
    };
    const moveBackward = () => {
        var _a;
        if (currentMainStep > 0 || currentSubstep > 0) {
            if (currentSubstep > 0) {
                setCurrentSubStep((prev) => prev - 1);
            }
            else {
                setCurrentMainStep((prev) => prev - 1);
                const previousSubsteps = ((_a = config[currentMainStep - 1].substeps) === null || _a === void 0 ? void 0 : _a.length) || 0;
                delayChange(() => setCurrentSubStep(previousSubsteps), () => setCurrentSubStep(previousSubsteps - 1));
            }
        }
    };
    const setPosition = (mainStep, subStep = 0) => {
        var _a;
        if (mainStep === config.length) {
            setCurrentMainStep(mainStep);
            setCurrentSubStep(0);
        }
        else if (mainStep >= 0 && mainStep < config.length) {
            const maxSubsteps = ((_a = config[mainStep].substeps) === null || _a === void 0 ? void 0 : _a.length) || 0;
            if (subStep >= 0 && subStep < maxSubsteps) {
                setCurrentMainStep(mainStep);
                setCurrentSubStep(subStep);
            }
        }
    };
    const clearProgressBar = () => {
        setCurrentMainStep(-1);
        setCurrentSubStep(0);
    };
    return {
        currentMainStep,
        currentSubstep,
        moveForward,
        moveBackward,
        setPosition,
        clearProgressBar,
    };
};
// everything is zero-indexed
export default function ImpProgressBar({ currentMainStep = 0, currentSubstep = 0, flag = true, width = '100%', numbered = true, config, checkmarkOnComplete = false }) {
    const getState = (completeCondition, currentCondition) => {
        if (currentCondition)
            return 'current';
        if (completeCondition)
            return 'complete';
        return 'incomplete';
    };
    return (React.createElement(ImpContainer, { width: width, dataTestId: "progress-bar-container" },
        React.createElement(ImpFlex, { direction: "row", align: "center", fluid: true, dataTestId: "progress-bar-flex" },
            config.map((step, index) => {
                return (React.createElement(React.Fragment, { key: index },
                    React.createElement(ImpFlexItem, { transition: FLEX_ITEM_TRANSITION_DURATION, flexGrow: currentMainStep === index && step.substeps ? 3 : 1, dataTestId: "flex-item-container" },
                        React.createElement(ImpFlex, { direction: "row", align: "center", fluid: true, dataTestId: "flex-container" },
                            React.createElement(ImpFlexItem, { transition: FLEX_ITEM_TRANSITION_DURATION, flexGrow: 1 },
                                React.createElement(ImpProgressBarItem, { label: index + 1, state: getState(currentMainStep >= index, currentMainStep === index && !step.substeps), transitionDelay: currentMainStep === index ? TRANSITION_DURATION : '0s', checkmarkOnComplete: checkmarkOnComplete })),
                            step.substeps && index === currentMainStep && (React.createElement(ImpFlexItem, { transition: FLEX_ITEM_TRANSITION_DURATION, flexGrow: step.substeps.length, dataTestId: "sub-flex-item-container" },
                                React.createElement(ImpFlex, { align: "center", fluid: true, dataTestId: "sub-flex-container" }, step.substeps.map((substep, subIndex) => (React.createElement(ImpProgressBarItem, { isSubstep: true, key: subIndex, state: getState(currentSubstep > subIndex &&
                                        index === currentMainStep, currentSubstep === subIndex &&
                                        index === currentMainStep), transitionDelay: currentSubstep === subIndex &&
                                        index === currentMainStep
                                        ? TRANSITION_DURATION
                                        : '0s' }))))))))));
            }),
            flag && (React.createElement(ImpFlexItem, { flexGrow: 0, dataTestId: "flag-item" },
                React.createElement(ImpProgressBarItem, { labelIcon: Icons.flag, state: currentMainStep === config.length ? 'complete' : 'incomplete', isEnd: true, transitionDelay: TRANSITION_DURATION }))))));
}
//# sourceMappingURL=ImpProgressBar.js.map